export default "__VITE_ASSET__076fa9eb__"